import { createReducer } from 'typesafe-actions'
import { User } from 'oidc-client-ts'

import {
    loginAsync,
    loginStart,
    resetGrpAuthState,
    setIsLoading,
    setShouldConnect,
    setShouldConnectFromLoginComponent,
    logout,
    updateUserAfterRefresh,
} from '../actions/app/e3DGrpAuth.actions'
import { getPersistedE3DGrpAuth } from '../persistLocalStorageE3DAuthState'

export type E3DGrpAuthState = {
    user: User | null
    shouldConnect: boolean
    shouldConnectFromLoginComponent: boolean
    loading: boolean
    isLoggedIn: boolean
    error: string | null
}

const defaultInitialState: E3DGrpAuthState = {
    user: null,
    shouldConnect: false,
    shouldConnectFromLoginComponent: false,
    loading: false,
    isLoggedIn: false,
    error: null,
}

const persistedState = getPersistedE3DGrpAuth()
const initialState: E3DGrpAuthState = persistedState || defaultInitialState

export const e3DGrpAuthReducer = createReducer(initialState)
    .handleAction(loginStart, (state) => ({
        ...state,
    }))
    .handleAction(loginAsync.request, (state) => {
        return {
            ...state,
            loading: true,
            error: null,
        }
    })
    .handleAction(loginAsync.success, (state, action) => {
        return {
            ...state,
            user: action.payload,
            loading: false,
            isLoggedIn: true,
            error: null,
        }
    })
    .handleAction(loginAsync.failure, (state, action) => {
        return {
            ...state,
            user: null,
            loading: false,
            isLoggedIn: false,
            error: action.payload,
        }
    })
    .handleAction(setIsLoading, (state, action) => ({
        ...state,
        loading: action.payload,
    }))
    .handleAction(logout, (state) => {
        return {
            ...state,
            user: null,
            isLoggedIn: false,
            loading: false,
            error: null,
        }
    })
    .handleAction(setShouldConnect, (state, action) => ({
        ...state,
        shouldConnect: action.payload,
    }))
    .handleAction(setShouldConnectFromLoginComponent, (state, action) => ({
        ...state,
        shouldConnectFromLoginComponent: action.payload,
    }))
    .handleAction(updateUserAfterRefresh, (state, action) => ({
        ...state,
        user: action.payload,
    }))
    .handleAction(resetGrpAuthState, () => defaultInitialState)

export default e3DGrpAuthReducer
